import "./index.scss";

import React from "react";

const InputMessage = ({
  error = "Эт поле обязательно к заполнению",
  placeholderText,
  isValue,
}) => {
  return (
    <div
      className={`input-message ${
        error ? "input-message--error" : isValue ? "input-message--active" : ""
      }`}
    >
      {error ? error : isValue ? placeholderText : ""}
    </div>
  );
};

export default InputMessage;
